import { render } from "./LuaChonDiemXuong.vue?vue&type=template&id=10f7d4aa&scoped=true"
import script from "./LuaChonDiemXuong.vue?vue&type=script&lang=js"
export * from "./LuaChonDiemXuong.vue?vue&type=script&lang=js"

import "./LuaChonDiemXuong.vue?vue&type=style&index=0&id=10f7d4aa&lang=scss&scoped=true"
import "./LuaChonDiemXuong.vue?vue&type=style&index=1&id=10f7d4aa&lang=css"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f7d4aa"]])

export default __exports__